import {useEffect, useState} from 'react'
import {getGuidesList} from '@/services/header/notifications'

const useHeaderGuides = () => {
  const [pageNo] = useState<number>(1)
  const [loading, setLoading] = useState<boolean>(true)
  const [fetchData, setFetchData] = useState<boolean>(true)
  const [refresh, setRefresh] = useState<boolean>(false)
  const [isRecall, setIsRecall] = useState<boolean>(false)
  const [ended] = useState<boolean>(false)
  const [headerGuidesData, setHeaderGuidesData] = useState<any[]>([])

  const refetch = ({isRefresh}: {isRefresh?: boolean}) => {
    if (isRefresh) {
      setRefresh(true)
      setIsRecall(true)
    } else {
      if (isRecall) {
        setIsRecall(false)
      }
    }
    setFetchData(true)
  }

  useEffect(() => {
    if (!fetchData) return
    if (!refresh && ended) return

    setLoading(true)
    const abortController = new AbortController()
    let isMounted = true

    getGuidesList({
      pageNo: refresh ? 1 : pageNo,
      signal: abortController.signal,
    })
      .then((response: any) => {
        if (isMounted) {
          setHeaderGuidesData(response?.data ? response?.data : [])
          // if (!refresh) {
          //   const hasMore = response?.HAS_MORE === 1
          //   if (hasMore) {
          //     setPageNo(pageNo + 1)
          //   } else {
          //     setEnded(true)
          //   }
          // }
        }
      })
      .catch((error: any) => {
        if (isMounted) {
          // openToastNotification({
          //   title: 'Có lỗi xảy ra, vui lòng thử lại sau.',
          //   type: 'error',
          // })
          console.log(error)
        }
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false)
          setFetchData(false)
          if (refresh) {
            setRefresh(false)
          }
        }
      })

    return () => {
      isMounted = false
      abortController.abort()
    }
  }, [fetchData])

  return {
    loading,
    headerGuidesData,
    refetch,
    isRecall,
  }
}

export default useHeaderGuides
